export const AccordionAnswer = ({ answer }: { answer: string }) => {
  return (
    <p className="text-white first-letter:uppercase text-[20px] font-normal">
      {answer}
    </p>
  )
}
